import { Controller } from '@hotwired/stimulus';

// The Configure button lives in the page header, outside the billable <form>,
// so it cannot bind billable-form actions directly. This controller bridges
// the click to the billable-form controller through an outlet.
export default class extends Controller {
  static outlets = ['billable-form'];

  open() {
    this.billableFormOutlet.openBodyModal(this.element);
  }
}
